// @ts-ignore: autogenerated import
import type * as Types from '../../../types/global';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LivestreamUpdateQueryVariables = Types.Exact<{
	rowId: Types.Scalars['Int']['input'];
	withVideoOnDemand: Types.Scalars['Boolean']['input'];
}>;

export type LivestreamUpdateQuery = {
	__typename?: 'Query';
	moduleByRowId?: {
		__typename?: 'Module';
		rowId: number;
		livestream?: {
			__typename?: 'ModuleLivestream';
			start?: string | null;
			end?: string | null;
			hls?: string | null;
			programme?: {
				__typename?: 'MangoProgramme';
				copyright?: string | null;
				title?: string | null;
				videoFiles?: {
					__typename?: 'MangoVideoFileConnection';
					nodes?: Array<{ __typename?: 'MangoVideoFile'; publicLocation?: string | null } | null> | null;
				} | null;
			} | null;
		} | null;
	} | null;
};

export const LivestreamUpdateDocument = gql`
	query LivestreamUpdate($rowId: Int!, $withVideoOnDemand: Boolean!) {
		moduleByRowId(rowId: $rowId) {
			rowId
			livestream {
				start
				end
				hls
				programme: mangoProgramme @include(if: $withVideoOnDemand) {
					copyright
					title
					videoFiles(filter: { videoProfile: { id: { eq: "av:http://ard.de/ontologies/audioVideo#VideoProfile_HLS" } } }) {
						nodes {
							publicLocation
						}
					}
				}
			}
		}
	}
`;

/**
 * __useLivestreamUpdateQuery__
 *
 * To run a query within a React component, call `useLivestreamUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLivestreamUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivestreamUpdateQuery({
 *   variables: {
 *      rowId: // value for 'rowId'
 *      withVideoOnDemand: // value for 'withVideoOnDemand'
 *   },
 * });
 */
export function useLivestreamUpdateQuery(
	baseOptions: Apollo.QueryHookOptions<LivestreamUpdateQuery, LivestreamUpdateQueryVariables> &
		({ variables: LivestreamUpdateQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>(LivestreamUpdateDocument, options);
}
export function useLivestreamUpdateLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>(LivestreamUpdateDocument, options);
}
export function useLivestreamUpdateSuspenseQuery(
	baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>
) {
	const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>(LivestreamUpdateDocument, options);
}
export type LivestreamUpdateQueryHookResult = ReturnType<typeof useLivestreamUpdateQuery>;
export type LivestreamUpdateLazyQueryHookResult = ReturnType<typeof useLivestreamUpdateLazyQuery>;
export type LivestreamUpdateSuspenseQueryHookResult = ReturnType<typeof useLivestreamUpdateSuspenseQuery>;
export type LivestreamUpdateQueryResult = Apollo.QueryResult<LivestreamUpdateQuery, LivestreamUpdateQueryVariables>;
